/**
 * Blog grid AJAX pagination.
 *
 * Migrated from WPCode snippet #1317, which inlined this script into every
 * render of the [pf_blog_grid] shortcode.
 *
 * Changes from the original:
 *  - The ajax URL and nonce are read from data attributes on the grid instead
 *    of being interpolated into inline JS by PHP.
 *  - A nonce is sent, matching check_ajax_referer() in the AJAX handler.
 *  - The click handler is bound to the grid's wrapper rather than `document`.
 */

function initBlogGrid() {
  const grid = document.getElementById('pf-blog-grid');

  if (!grid) return;

  const wrapper = grid.closest('.pf-blog-grid-wrapper');
  const ajaxUrl = grid.dataset.ajaxUrl;
  const nonce = grid.dataset.nonce;

  if (!wrapper || !ajaxUrl) return;

  wrapper.addEventListener('click', async (event) => {
    const btn = event.target.closest('.pf-page-btn');

    if (!btn || btn.classList.contains('active')) return;

    event.preventDefault();

    const page = btn.getAttribute('data-page');

    wrapper.querySelectorAll('.pf-page-btn').forEach((b) => b.classList.remove('active'));
    btn.classList.add('active');
    grid.classList.add('loading');

    const body = new FormData();
    body.append('action', 'pf_blog_pagination');
    body.append('page', page);
    body.append('nonce', nonce);

    try {
      const response = await fetch(ajaxUrl, {
        method: 'POST',
        body,
        credentials: 'same-origin',
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      grid.innerHTML = await response.text();

      const listing = document.querySelector('.pf-blog-listing');

      if (listing) {
        window.scrollTo({
          top: listing.getBoundingClientRect().top + window.pageYOffset - 50,
          behavior: 'smooth',
        });
      }
    } catch (error) {
      console.error('Blog pagination failed.', error);
    } finally {
      grid.classList.remove('loading');
    }
  });
}

if (document.readyState !== 'loading') {
  initBlogGrid();
} else {
  document.addEventListener('DOMContentLoaded', initBlogGrid);
}
